export const authServerUrl = (keycloak) => {
    const authServerUrl = keycloak.authServerUrl;
    return authServerUrl.charAt(authServerUrl.length - 1) === '/' ? authServerUrl : authServerUrl + '/';
};
export const audiencePresent = (keycloak) => {
    if (keycloak.tokenParsed) {
        const audience = keycloak.tokenParsed['aud'];
        return audience === 'account' || (Array.isArray(audience) && audience.indexOf('account') >= 0);
    }
    return false;
};
